<template>
  <generic-page
    :image="content.img.url"
    image-height="90vh"
  >
    <news-card
      v-for="item in contents"
      :key="item['.key']"
      :item="item"
      with-link
    />
    <v-pagination
      v-if="totalPages > 1"
      v-model="page"
      :length="totalPages"
      class="pb-3"
      @input="getContent"
    />
  </generic-page>
</template>

<script>
import newsCard from "../components/newsCard";
import genericPage from "../components/genericPage";
export default {
  name: "NewsList",
  components: { newsCard, genericPage },
  data() {
    return {
      contents: null,
      page: 1,
      totalPages: 1,
      content: {
        title: null,
        body: [],
        img: ""
      }
    };
  },
  watch: {
    $route() {
      this.getContent();
    }
  },
  created() {
    this.getContent();
  },
  methods: {
    track() {
      this.$ga.page(this.$router);
    },
    isMobile() {
      return !this.$vuetify.breakpoint.mdAndUp;
    },
    async getContent() {
      const { data } = await this.$prismic.client.getByUID(
        "puslapiai",
        this.$route.path.substring(1)
      );
      this.content = {
        ...this.content,
        img: this.isMobile()
          ? data.virsutinis_paveikslelis.mobile
          : data.virsutinis_paveikslelis
      };;
      // eslint-disable-next-line
      const { results, total_pages } = await this.$prismic.client.query(
        this.$prismic.Predicates.at("document.type", "naujienos"),
        {
          orderings: "[document.first_publication_date desc]",
          page: this.page,
          pageSize: 10
        }
      );
      // eslint-disable-next-line
      this.totalPages = total_pages;
      this.contents = results.map(({ data, uid }) => ({
        uid,
        title: data.antraste[0].text,
        body: data.tekstas,
        img: this.isMobile() ? data.paveikslelis.mobile : data.paveikslelis,
        imgVertical: this.isMobile() ? data.paveikslelis_vertikalus.mobile : data.paveikslelis_vertikalus
      }));
    }
  }
};
</script>

<style></style>
